const shipperService = {
    get(id) {
        return axios.get('/api/v1/shipper/' + id).then(
            (response) => {
                return response.data.data;
            }
        )
    },
    getAll() {
        return axios.get('/api/v1/shipper').then(
            (response) => {
                return response.data.data;
            }
        )
    },
    create(data) {
        return axios.post('/api/v1/shipper', data).then(
            (response) => {
                return response.data.data;
            }
        );

    },
    update(id, data) {
        return axios.put('/api/v1/shipper/' + id, data).then(
            (response) => {
                return response.data.data;
            }
        );

    },
    delete(id) {
        return axios.post('/api/v1/shipper/' + id +"/delete",).then(
            (response) => {
                return response.data.data;
            }
        );

    },
};

export default shipperService;